import React from "react";
import MetaForm from "./MetaForm";

function App() {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-center text-gray-900 mb-8">
          Free Keyword Clustering Tool
        </h1>
        <p className="text-center text-gray-600 mb-8 max-w-3xl mx-auto">
          Analyze your content, generate comprehensive keyword clusters, and
          discover new SEO opportunities. Our AI-powered tool expands upon your
          initial keywords to provide valuable insights for content strategy and
          topical authority.
        </p>
        <MetaForm />
        <div className="mt-12 text-center text-gray-600">
          <h2 className="text-2xl font-semibold mb-4">How It Works</h2>
          <ol className="list-decimal list-inside text-left max-w-3xl mx-auto">
            <li className="mb-2">
              Enter your content or a list of keywords in the text editor above.
            </li>
            <li className="mb-2">
              Click "Generate Clusters" to analyze your input.
            </li>
            <li className="mb-2">
              Our AI will create comprehensive keyword clusters, including
              relevant terms you might have missed.
            </li>
            <li className="mb-2">
              Review the clusters to inform your content strategy and SEO
              efforts.
            </li>
            <li>
              Use the insights to create more targeted, comprehensive content
              that establishes topical authority.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
}

export default App;
